import axios from 'axios';
import environment from 'src/environment/environment';
import { IGeocoderRequest } from 'src/models';

export class GeocoderService {
	static baseUrl = environment.apiGateway.geocoderApiUrl + 'geocoder';

	/**
	 * Get geocode
	 */
	public static async getGeocoder(data: IGeocoderRequest) {
		try {
			const params = {
				pincode: data.pincode ? data.pincode.toString().slice(0, 6) : '',
				city: data.city,
				countryCode: data.countryCode,
				stateCode: data.stateCode,
				addressLine1: data.addressLine1,
				addressLine2: data.addressLine2
			};
			const res = await axios.get(this.baseUrl, { params });
			return res;
		} catch (error: any) {
			let err;
			if (error.response) {
				err = error.response.data;
			} else {
				err = {
					error: 'Invalid request',
				};
			}
			throw err.error;
		}
	}
}
